import request from '@/utils/request'
import { detectiveUrl } from '@/env'

// export function searchAdvertise(state) {
//     return request({
//         url: `${detectiveUrl()}/api/advertise/list`,
//         method: 'post',
//         data: state,
//     })
// }

// export function getAdvertiseOne(state) {
//     return request({
//         url: `${detectiveUrl()}/api/advertise/${state.id}`,
//         method: 'post',
//         params: state.params,
//         data: state.data,
//     })
// }

export function getAdvertise(state) {
    return request({
        url: `${detectiveUrl()}/api/advertise/list`,
        method: 'post',
        params: state.params,
        data: state.data
    })
}

export function addAdvertise(state) {
    return request({
        url: `${detectiveUrl()}/api/advertise/add`,
        method: 'post',
        data: state
    })
}

export function editAdvertise(state) {
    return request({
        url: `${detectiveUrl()}/api/advertise/edit/${state.id}`,
        method: 'put',
        data: state
    })
}

export function editAdvertiseStatus(state) {
    return request({
        url: `${detectiveUrl()}/api/advertise/edit/${state.id}`,
        method: 'put',
        data: {
            status: state.status
        }
    })
}

export function deleteAdvertise(state) {
    return request({
        url: `${detectiveUrl()}/api/advertise/delete/${state}`,
        method: 'delete'
    })
}
